//  __         __     __   __     ______     __  __     ______        __   __     ______     ______  
// /\ \       /\ \   /\ "-.\ \   /\  ___\   /\ \/ /    /\  ___\      /\ "-.\ \   /\  ___\   /\__  _\ 
// \ \ \____  \ \ \  \ \ \-.  \  \ \ \__ \  \ \  _"-.  \ \  __\      \ \ \-.  \  \ \  __\   \/_/\ \/ 
//  \ \_____\  \ \_\  \ \_\"\_\  \ \_____\  \ \_\ \_\  \ \_____\     \ \_\"\_\  \ \_____\    \ \_\ 
//   \/_____/   \/_/   \/_/ \/_/   \/_____/   \/_/\/_/   \/_____/      \/_/ \/_/   \/_____/     \/_/ 
//                                                                                                   
// 所有权利归Lingke Network (china)所有 | dream_pep拥有其艺术改变权力
// 未经允许的情况下删除此版权头可能会受到民事指控
// 请勿在未经Lingke Network (china)允许的范围内修改代码并分发

export const AUTH_ERRORS = {
  INVALID_CREDENTIALS: "邮箱或密码不正确",
  LOGIN_FAILED: "登录失败，请稍后重试",
  REGISTRATION_FAILED: "注册失败，请稍后重试",
} as const;

